<p-toast position="bottom-center"></p-toast>
<p-confirmDialog></p-confirmDialog>

<app-events-calendar
  [editable]="true"
  [eventTypeSelectMode]="'multiple'"
  [streamingData]="true"
  (eventClicked)="surgery.addEvent($event)"
  (eventDropped)="surgery.addEvent($event)"
  (eventResized)="surgery.addEvent($event)"
  (eventRightClicked)="onEventRightClick($event)"
  (selected)="surgery.addEvents($event)"
>
</app-events-calendar>

<p-contextMenu [model]="contextMenuItems"></p-contextMenu>

<app-event-surgery-table #surgery [allDataUserMap]="allDataUserMap | async" [orgData]="orgData | async">
</app-event-surgery-table>
